/**
 * Fire-and-forget POST of a client-side error to /api/client-error, which logs
 * it server-side via the shared Powertools logger (lands in CloudWatch).
 * Never throws — a reporting failure must not break the caller.
 */
export function reportClientError(error: unknown, extra?: Record<string, unknown>) {
  try {
    const payload = {
      message: error instanceof Error ? error.message : String(error),
      stack: error instanceof Error ? error.stack : undefined,
      url: typeof window !== "undefined" ? window.location.href : undefined,
      ...extra,
    };
    void fetch("/api/client-error", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
  } catch {
    // never let error reporting itself throw
  }
}
